import { Group, Drawer, Text, Button } from "@mantine/core";
import { useRegisterSW } from "virtual:pwa-register/react";

function PWA() {
  // check for updates every 5 minutes
  const period = 5 * 60 * 1000;

  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, r) {
      if (period <= 0) return;
      if (r?.active?.state === "activated") {
        registerPeriodicSync(period, swUrl, r);
      } else if (r?.installing) {
        r.installing.addEventListener("statechange", (e) => {
          const sw = e.target as ServiceWorker;
          if (sw.state === "activated") registerPeriodicSync(period, swUrl, r);
        });
      }
    },
  });

  function close() {
    setNeedRefresh(false);
  }

  return (
    <Drawer
      opened={needRefresh}
      onClose={close}
      title="New version detected!"
      position="bottom"
      size="12.5rem"
    >
      <Text>
        A new version is available, click on update button to load it.
      </Text>

      <Group justify="end" mt="xl">
        <Button variant="default" onClick={close}>
          Close
        </Button>
        <Button
          onClick={() => {
            updateServiceWorker(true);
            close();
          }}
        >
          Update
        </Button>
      </Group>
    </Drawer>
  );
}

export default PWA;

/**
 * This function will register a periodic sync check every hour, you can modify the interval as needed.
 */
function registerPeriodicSync(
  period: number,
  swUrl: string,
  r: ServiceWorkerRegistration,
) {
  if (period <= 0) return;

  setInterval(async () => {
    if ("onLine" in navigator && !navigator.onLine) return;

    const resp = await fetch(swUrl, {
      cache: "no-store",
      headers: {
        cache: "no-store",
        "cache-control": "no-cache",
      },
    });

    if (resp?.status === 200) await r.update();
  }, period);
}
